<template>
  <div class="main" v-if="!loading">
    <!-- 标题 -->
    <div class="herder-title">微信绑定</div>

    <!-- 说明提示文字 -->
    <div class="tips-box">
      <div class="tips-content">检测到您尚未绑定账号，请选择以下操作：</div>
      <div class="tips-sub">
        如您已有账号，请登录进行绑定；<br />
        如没有账号，请先注册后再绑定。
      </div>
    </div>

    <!-- 前往注册按钮 -->
    <button class="btn btn-register" @click="goToRegister">注册绑定</button>

    <!-- 前往登录按钮 -->
    <button class="btn btn-login" @click="goToLogin">登录绑定</button>
  </div>
</template>

<script>
import { getWeChatCallback, getAccount } from "@/api/mobile";
export default {
  data() {
    return {
      code: "",
      state: "",
      loading: true,
    };
  },
  methods: {
    goToRegister() {
      this.$router.push(`/mobile/register?code=${this.code}&state=${this.state}`);
    },
    goToLogin() {
      this.$router.push(`/mobile/login?code=${this.code}&state=${this.state}`);
    },
  },
  created() {
    this.code = this.$route.query.code;
    this.state = this.$route.query.state;
    getWeChatCallback({
      code: this.code,
      state: this.state,
    })
      .then((res) => {
        if (res.code === 200) {
          localStorage.setItem("token", res.data.token);
          getAccount().then((res) => {
            if (res.code === 200) {
              localStorage.setItem("userInfo", JSON.stringify(res.data));
              this.$router.push("/mobile/home");
            } else {
              this.loading = false;
            }
          }).catch(() => {
            this.loading = false;
          });
        } else {
          this.loading = false;
        }
      })
      .catch(() => {
        this.loading = false;
      });
  },
};
</script>

<style lang="scss" scoped>
.main {
  width: 100%;
  min-height: calc(100vh - 125px);
  background-color: #faf8ff;
  background-image: url("../../assets/mobile/image/common/shadow.png");
  background-size: cover;
  background-position: 100% 100%;
  background-repeat: no-repeat;
  padding-top: 85px;
  padding-bottom: 40px;

  .herder-title {
    text-align: center;
    color: #232323;
    font-size: 23px;
    font-weight: bolder;
  }

  // 说明提示框
  .tips-box {
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    width: 90%;
    max-width: 334px;
    background: #ffffff;
    border-radius: 16px;
    padding: 25px 20px;
    margin-top: 40px;
    box-shadow: 0 2px 12px rgba(136, 70, 255, 0.1);
    box-sizing: border-box;

    .tips-content {
      color: #232323;
      font-size: 16px;
      font-weight: 500;
      line-height: 1.6;
      margin-bottom: 12px;
      word-wrap: break-word;
      word-break: break-word;
    }

    .tips-sub {
      color: #666666;
      font-size: 14px;
      line-height: 1.8;
      word-wrap: break-word;
      word-break: break-word;
    }
  }

  // 按钮通用样式
  .btn {
    padding: 0;
    border: none;
    width: 90%;
    max-width: 334px;
    height: 50px;
    border-radius: 25px;
    color: #fff;
    display: block;
    margin-left: auto;
    margin-right: auto;
    font-size: 16px;
    cursor: pointer;
    transition: opacity 0.3s;

    &:active {
      opacity: 0.7;
    }
  }

  // 前往注册按钮 - 渐变紫色
  .btn-register {
    background: linear-gradient(138deg, #c2a0ff 0%, #8846ff 100%);
    margin-top: 50px;
  }

  // 前往登录按钮 - 白色背景紫色边框
  .btn-login {
    background: #ffffff;
    color: #8846ff;
    border: 2px solid #8846ff;
    margin-top: 15px;
  }
}
</style>
